module.exports = __webpack_public_path__ + "static/media/water.1094adf9.svg";